import { Stack, Typography } from '@mui/material';
import {
  CHECKOUT_PAYMENT_RESPONSE,
  SURCHARGE_ITEM_DATA,
} from 'models/payments';
import { formatPrice } from 'utils';

interface SurchargeListProps {
  dataCheckoutPayment: CHECKOUT_PAYMENT_RESPONSE;
  isShowPaymentGatewayFee: boolean;
}

const AdjustmentSurchargeItem = (props: SURCHARGE_ITEM_DATA) => {
  const { description, parent_rate } = props;

  return (
    <Stack>
      <Typography variant="Components_Column_content" color="#6d6d6d">
        {description}
      </Typography>
      <Typography variant="Components_Column_content" color="#6d6d6d">
        +{formatPrice(parent_rate)}
      </Typography>
    </Stack>
  );
};

export const SurchargeList = ({
  dataCheckoutPayment,
  isShowPaymentGatewayFee,
}: SurchargeListProps) => {
  const {
    adjustment_surcharges,
    payment_gateway_fee,
    additional_child_surcharge,
    odd_hour_surcharge,
    weekend_surcharge,
    public_holiday_surcharge,
  } = dataCheckoutPayment;
  return (
    <>
      {adjustment_surcharges?.map((adjItem) => (
        <AdjustmentSurchargeItem {...adjItem} />
      ))}

      {additional_child_surcharge && (
        <Stack>
          <Typography variant="Components_Column_content" color="#6d6d6d">
            {additional_child_surcharge.title}
          </Typography>
          <Typography variant="Components_Column_content" color="#6d6d6d">
            {formatPrice(additional_child_surcharge.amount)}
          </Typography>
        </Stack>
      )}

      {odd_hour_surcharge && (
        <Stack>
          <Typography variant="Components_Column_content" color="#6d6d6d">
            {odd_hour_surcharge.title}
          </Typography>
          <Typography variant="Components_Column_content" color="#6d6d6d">
            {formatPrice(odd_hour_surcharge.amount)}
          </Typography>
        </Stack>
      )}

      {weekend_surcharge && (
        <Stack>
          <Typography variant="Components_Column_content" color="#6d6d6d">
            {weekend_surcharge.title}
          </Typography>
          <Typography variant="Components_Column_content" color="#6d6d6d">
            {formatPrice(weekend_surcharge.amount)}
          </Typography>
        </Stack>
      )}

      {public_holiday_surcharge && (
        <Stack>
          <Typography variant="Components_Column_content" color="#6d6d6d">
            {public_holiday_surcharge.title}
          </Typography>
          <Typography variant="Components_Column_content" color="#6d6d6d">
            {formatPrice(public_holiday_surcharge.amount)}
          </Typography>
        </Stack>
      )}

      {isShowPaymentGatewayFee && payment_gateway_fee && (
        <Stack>
          <Typography variant="Components_Column_content" color="#6d6d6d">
            {payment_gateway_fee.title} ({payment_gateway_fee.percentage}%)
          </Typography>
          <Typography variant="Components_Column_content" color="#6d6d6d">
            {formatPrice(payment_gateway_fee.amount)}
          </Typography>
        </Stack>
      )}
    </>
  );
};
